<ng-container *ngIf="isDesktop || !cardLayoutForMobile">
  <table class="table default-font">
    <thead class="thead">
      <tr>
        <ng-container *ngFor="let column of columns">
            <th class="th" width="{{column?.width}}" 
                [ngStyle]="{'white-space': column.headerNoWrap?'nowrap':'', 'text-align': column.alignRight?'right':''}">
                {{ column.displayName }}
            </th>
        </ng-container>
      </tr>
    </thead>

    <tbody class="tbody">
      <ng-container *ngFor="let row of rows; let i = index">
        <tr
          class="tr"
          [class.darker-row]="isOdd(i) && alternateLineColors"
          [class.border-bottom]="!alternateLineColors"
        >
          <ng-container *ngFor="let item of columns">
            <ng-container *ngIf="item.name !== openSubRowsId">
              <td class="td">
                <ng-container
                  *ngTemplateOutlet="cellContentTemplate; context: { index: i, column: item, row: row }"
                ></ng-container>
              </td>
            </ng-container>

            <ng-container *ngIf="item.name === openSubRowsId && hasSubRowItems(i)">
              <td class="td  screen-only"
                [class.clickable]="allowRowClick || hasSubRowItems(i)"
                (click)="emitRowClick(row, i)">
                <div class="open-sub-rows-icon">
                  <app-lucide-icon [iconName]="getOpenSubRowIconName(i)" [size]="20"></app-lucide-icon>
                </div>
              </td>
            </ng-container>
          </ng-container>
        </tr>

        <!-- SUBLISTAS -->
        <ng-container *ngIf="hasSubRowItems(i) && displaySubRowItems(i)">
          <tr class="tr darker-row border-bottom screen-only">
            <ng-container *ngFor="let item of subColumns">
              <td class="td">
                <div class="cell-content bold">
                  <span>{{ item.displayName }}</span>
                </div>
              </td>
            </ng-container>
          </tr>

          <ng-container *ngFor="let subRow of subRows[i]; let h = index">
            <tr class="tr darker-row border-bottom screen-only">
              <ng-container *ngFor="let subColumn of subColumns">
                <td class="td">
                  <ng-container
                    *ngTemplateOutlet="cellContentTemplate; context: { index: null, column: subColumn, row: subRow }"
                  ></ng-container>
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </ng-container>
        
        <!-- SUBLISTAS IMPRESSÃO-->
        <ng-container *ngIf="hasSubRowItems(i)" >
          <tr class="tr darker-row border-bottom print-only">
            <ng-container *ngFor="let item of subColumns">
              <td class="td">
                <div class="cell-content bold">
                  <span>{{ item.displayName }}</span>
                </div>
              </td>
            </ng-container>
          </tr>

          <ng-container *ngFor="let subRow of subRows[i]; let h = index">
            <tr class="tr darker-row border-bottom print-only">
              <ng-container *ngFor="let subColumn of subColumns">
                <td class="td">
                  <ng-container
                    *ngTemplateOutlet="cellContentTemplate; context: { index: null, column: subColumn, row: subRow }"
                  ></ng-container>
                </td>
              </ng-container>
            </tr>
          </ng-container>
        </ng-container>

      </ng-container>
    </tbody>
  </table>
</ng-container>

<ng-container *ngIf="!isDesktop && cardLayoutForMobile">
  <ng-container *ngFor="let row of rows; let i = index">
    <div
      class="row-card default-font"
      [class.clickable]="allowRowClick"
      [class.margin-bottom]="getCardMarginBottomCondition(rows, i)"
      [class.straight-border-bottom]="hasSubRowItems(i) && displaySubRowItems(i)"
    >
      <ng-container *ngFor="let item of columns; let j = index">
        <ng-container *ngIf="item?.name !== tableFakeColumnNameConstant">
          <ng-container *ngIf="item?.name !== openSubRowsId">
            <div class="line" [class.border-bottom]="!isLastItem(columns, j) || hasSubRowItems(i)">
              <div>
                <span  class="line-column-text" [ngStyle]="{'white-space': item.headerNoWrap?'nowrap':''}">{{  item.displayName  }}</span>
              </div>
              <div>
                <ng-container
                  *ngTemplateOutlet="cellContentTemplate; context: { index: i, column: item, row: row }"
                ></ng-container>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="item?.name === openSubRowsId && hasSubRowItems(i)">
            <div class="line no-flex">
              <div>
                <app-button
                  [text]="getDisplaySubRowItemsButtonText(i)"
                  [fullWidth]="true"
                  (clickEvent)="emitRowClick(row, i)"
                ></app-button>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <ng-container *ngIf="hasSubRowItems(i) && displaySubRowItems(i)">
      <ng-container *ngFor="let subRow of subRows[i]; let h = index">
        <div
          class="row-card default-font sub-row-card"
          [class.margin-bottom]="isLastItem(subRows[i], h) && !isLastItem(rows, i)"
          [class.round-border-bottom]="isLastItem(subRows[i], h)"
        >
          <ng-container *ngFor="let subColumn of subColumns; let k = index">
            <ng-container *ngIf="subColumn.name !== tableFakeColumnNameConstant">
              <div class="line" [class.border-bottom]="!isLastItem(subColumns, k)">
                <div>
                  <span class="line-column-text">{{ subColumn.displayName }}</span>
                </div>

                <div>
                  <ng-container
                    *ngTemplateOutlet="cellContentTemplate; context: { index: null, column: subColumn, row: subRow }"
                  ></ng-container>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>


<ng-template #cellContentTemplate let-i="index" let-item="column" let-row="row">
  <div
    class="cell-content" 
    [class.bold]="rowOptionsMapper && rowOptionsMapper[i] && rowOptionsMapper[i][item.name]?.bold"
    [class.clickable]="clickable(i, item.name)"
    [class.disabled]="rowOptionsMapper && rowOptionsMapper[i] && rowOptionsMapper[i][item.name]?.disabled"
    [class.align-right]="rowOptionsMapper && rowOptionsMapper[i] && rowOptionsMapper[i][item.name]?.alignRight"
    (click)="handleCellClick(i, item)"
  >  
    <ng-container *ngIf="rowOptionsMapper && rowOptionsMapper[i] && rowOptionsMapper[i][item.name]?.iconName">
      <div class="icon-container" [ngClass]="[getCellColor(i, item)]">
        <app-lucide-icon [iconName]="rowOptionsMapper && rowOptionsMapper[i] && rowOptionsMapper[i][item.name]?.iconName"
        ></app-lucide-icon>
      </div>
    </ng-container>

    <span [ngClass]="[getCellColor(i, item), getCellClass(i, item?.name) ]" [innerHtml]="row[item?.name]"></span>
  </div>
</ng-template>



<app-modal-table-detail #modalDetail></app-modal-table-detail>

<app-modal-table-description #modalDescription></app-modal-table-description>